import { render, staticRenderFns } from "./list.vue?vue&type=template&id=06c95ef8&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=06c95ef8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c95ef8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c95ef8')) {
      api.createRecord('06c95ef8', component.options)
    } else {
      api.reload('06c95ef8', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=06c95ef8&scoped=true&", function () {
      api.rerender('06c95ef8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/soundWall/list.vue"
export default component.exports